import { useState } from 'react';
import { Formik } from 'formik';
import successIcon from 'assets/img/iconregalo.svg';
import { Modal, ResponseModal, TextArea } from 'components';
import { initialValues, schema } from './config';
import { saveThanksMessage } from 'services/api/table';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';

export default function ThanksMessage({ tableId, orderId, show, onClose = () => {} }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);

  const handleClose = () => {
    onClose(currentStep);
    setCurrentStep(1);
  };

  const handleSubmit = (e) => {
    if(+tableId && +orderId) {
      dispatch(showLoader());
      const payload = {
        gift_table_id: tableId,
        thanks_messaage: e.motive,
      }
      saveThanksMessage(orderId, payload)
        .then((response) => {
          setShowConfirmationMessage(true);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  };
  const handleConfirmationClose = () => {
    setShowConfirmationMessage(false);
    onClose(currentStep);
    setCurrentStep(1);
    window.location.reload();
  };

  return (
    <>
      <ResponseModal
        title="Gracias, El mensaje fue enviado correctamente "
        icon={successIcon}
        show={showConfirmationMessage}
        onClose={handleConfirmationClose}
        onSubmit={handleConfirmationClose}
        codeClassName="text-danger text-center my-4"
      />
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {(formik) => {
          const { handleSubmit } = formik;
          return (
            <Modal
              show={show}
              title="Mensaje de agradecimiento"
              actionLabel="Enviar"
              onClose={handleClose}
              onSubmit={handleSubmit}
              className="pt-4 pb-1"
            >
              <TextArea name="motive" />
            </Modal>
          )
        }}
      </Formik>
    </>
  );
}
